module.exports = __webpack_public_path__ + "img/icon-nav2.3ce8fe0b.svg";